import styled, { css } from 'styled-components';

import { Color } from '../../../constants/Colors';
import { FontSize, FontWeight } from '../../../constants/Fonts';
import { Indexes, MediaQuery } from '../../../constants/Styles';
import { Typography } from '../../../constants/Typographies';

export const Footer = styled.footer`
  border-top: 1px solid ${Color.MYSTIC};
  color: ${Color.CLOUD_BURST};
  display: flex;
  width: 100%;
  height: auto;
  padding: 60px 16px;
  box-sizing: border-box;
  z-index: ${Indexes.FIXED};
  position: relative;
  justify-content: center;

  ${MediaQuery.M_AND_DOWN} {
    padding: 30px 20px;
  }
`;

export const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1280px;
  width: 100%;
  box-sizing: border-box;
`;

export const FooterWrapper = styled.div`
  box-sizing: border-box;
  display: flex;

  ${MediaQuery.M_AND_DOWN} {
    display: contents;
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: ${({ flexGrow }) => flexGrow || '1'};
  box-sizing: border-box;
  margin: 0;
  width: 100%;

  ul {
    list-style: none;
  }

  &:not(:last-child) {
    padding-right: 16px;
  }

  ${MediaQuery.M_AND_DOWN} {
    &:not(:last-child) {
      margin-bottom: 50px;
    }
  }
`;

export const LogoContainer = styled.div`
  width: 150px;
  height: 40px;
  margin-bottom: 20px;
`;

export const RootLog = styled.a``;

export const Logo = styled.img`
  width: 100%;
  height: 100%;

  &:hover {
    opacity: 0.3;
  }
`;

export const Slogan = styled.p`
  ${Typography.M_THINNER};
  color: ${Color.CLOUD_BURST};
`;

export const SocialNav = styled.ul`
  display: flex;
  margin-top: 15px;

  a:not(:last-child) {
    margin-right: 16px;
  }

  span:not(:last-child) {
    margin-right: 16px;
  }
`;

const ThemeSocialLink = css`
  display: flex;
  height: 30px;
  border-radius: 43.5px;
  align-items: center;
  justify-content: center;

  path {
    fill: url(#blue-gradient);
    font-size: ${FontSize.S};
    font-weight: 300;
  }
`;

export const SocialLink = styled.a`
  ${ThemeSocialLink};
`;

export const SocialLinkObfuscate = styled.span`
  ${ThemeSocialLink};
  cursor: pointer;
`;

export const ColumnTitle = styled.p`
  ${Typography.M_BOLDER};
  color: ${Color.CLOUD_BURST};
  margin-bottom: 16px;
`;

export const UnorderedLinks = styled.ul``;

export const LinkContainer = styled.li``;

const ThemeSectionLink = css`
  ${Typography.S_THINNER};
  line-height: 24px;
  color: ${Color.CLOUD_BURST};
  transition: none;

  &:hover {
    font-weight: ${FontWeight.BLACK};
  }
`;

export const SectionLink = styled.a`
  ${ThemeSectionLink};
`;

export const SectionLinkObfuscate = styled.span`
  ${ThemeSectionLink};
  cursor: pointer;
`;

export const ButtonCookie = styled.button`
  ${Typography.S_THINNER};
  color: ${Color.CLOUD_BURST};
  line-height: 22px;
  min-height: initial;
  width: fit-content;
  border: none;
  background-color: transparent;
  border: 2px solid transparent;
  padding: 0;
  margin: 0;
  border: 0;
  cursor: pointer;

  &:hover {
    font-weight: ${FontWeight.BLACK};
  }

  &:focus-visible {
    background-color: ${Color.WHISPER};
    border: 2px solid ${Color.CLOUD_BURST};
  }
`;
